import type { TripWizardConfig, WizardValues } from './types';

/** Build the starting answers, merging any seed from an edited trip. */
export function createInitialValues(
  config: TripWizardConfig,
  seed?: Partial<WizardValues>,
): WizardValues {
  const adultPax = seed?.adultPax ?? 2;
  const childrenBirthdates = seed?.childrenBirthdates ?? [];
  return {
    name: seed?.name ?? '',
    countries: seed?.countries ?? [],
    dmcId: seed?.dmcId ?? (config.dmc.mode === 'fixed' ? config.dmc.id : null),
    // Carried so the recap can name the operating DMC on a seeded (template /
    // draft) trip, not just when the user picks one live.
    dmcLabel: seed?.dmcLabel,
    startLocation: seed?.startLocation,
    endLocation: seed?.endLocation,
    departureDate: seed?.departureDate ?? null,
    duration: seed?.duration ?? 7,
    adultPax,
    childrenBirthdates,
    rooms: seed?.rooms ?? [
      {
        adults: adultPax,
        children: childrenBirthdates.length,
        childrenBirthdates,
      },
    ],
    themes: seed?.themes ?? [],
    hotelStyles: seed?.hotelStyles ?? [],
    brief: seed?.brief ?? '',
    locale: seed?.locale ?? config.locale,
  };
}
